import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
	toggleMultiExpansionPanel,
	setExpansionPanels,
	updateExpansionPanels,
} from 'actions/view'
import {
	ExpansionPanel,
	ExpansionPanelSummary,
	Typography,
	ExpansionPanelDetails,
	withStyles,
	IconButton,
	Tooltip,
	// Grid,
} from '@material-ui/core'
import { ExpandMore, Info, Error } from '@material-ui/icons'
import classNames from 'classnames'

const ExpansionPanelComponent = ({
	classes,
	children,
	current,
	last,
	disabled,
	expanded,
	prevExpanded,
	nextExpanded,
	toggleMultiExpansionPanel,
	idx,
	errors,
	customClassName,
	color,
	toolTipText,
	warning,
	noPadding,
}) => {
	const style = () => {
		if (expanded) {
			return null
		} else {
			if ((prevExpanded || idx === 0) && (nextExpanded || last)) {
				return { borderRadius: 35 }
			} else if (prevExpanded || idx === 0) {
				return { borderTopLeftRadius: 35, borderTopRightRadius: 35 }
			} else if (nextExpanded || last) {
				return { borderBottomLeftRadius: 35, borderBottomRightRadius: 35 }
			} else {
				return null
			}
		}
	}

	const Icon = errors ? Error : Info

	const expansionPanelSummaryClasses = {
		expandIcon: classes.expandIcon,
		expanded: classes.expansionPanelSummaryExpanded,
	}

	return (
		<ExpansionPanel
			className={customClassName || null}
			expanded={expanded}
			classes={{
				expanded: classes.expansionPanelExpanded,
			}}
			onChange={() => toggleMultiExpansionPanel(current)}
			style={style()}
		>
			<ExpansionPanelSummary
				classes={
					color
						? {
								root: classes[`${color}ExpansionPanel`],
								...expansionPanelSummaryClasses,
						  }
						: expansionPanelSummaryClasses
				}
				className={
					disabled
						? classes.expansionPanelSummaryDisabled
						: classes.expansionPanelSummary
				}
				expandIcon={<ExpandMore />}
				style={style()}
			>
				<Typography className={classNames(classes.heading, classes.color)}>
					{current}
				</Typography>
				<Tooltip title={toolTipText}>
					<IconButton
						disableRipple
						style={{ padding: 0 }}
						className={classNames(
							classes.headingIcon,
							errors
								? classes.error
								: warning
								? classes.warning
								: classes.color,
						)}
					>
						<Icon className={classes.icon} />
					</IconButton>
				</Tooltip>
			</ExpansionPanelSummary>
			<ExpansionPanelDetails
				style={
					prevExpanded && !expanded
						? {
								backgroundColor: 'transparent',
								padding: noPadding ? 0 : '15px 24px 24px',
						  }
						: { padding: noPadding ? 0 : '15px 24px 24px' }
				}
			>
				{children}
			</ExpansionPanelDetails>
		</ExpansionPanel>
	)
}

const styles = (theme) => ({
	expansionPanelExpanded: {
		borderRadius: '35px !important',
	},
	expandIcon: { color: '#fff' },
	expansionPanelSummaryExpanded: {
		borderTopLeftRadius: 35,
		borderTopRightRadius: 35,
	},
	expansionPanelSummary: { backgroundColor: theme.palette.secondary.main },
	expansionPanelSummaryDisabled: { backgroundColor: theme.palette.grey[300] },
	heading: {
		fontSize: '90%',
		fontWeight: 'bold',
		marginRight: 7,
	},
	color: { color: '#fff' },
	error: { color: theme.palette.red },
	waring: { color: theme.palette.orange },
	icon: { fontSize: '1rem' },
	greenExpansionPanel: { backgroundColor: theme.palette.green },
})

const CustomExpansionPanel = connect(
	(state, { current, prev, next }) => ({
		expanded: state.view.multiExpansionPanels[current],
		prevExpanded: prev && state.view.multiExpansionPanels[prev],
		nextExpanded: next && state.view.multiExpansionPanels[next],
	}),
	(dispatch) => bindActionCreators({ toggleMultiExpansionPanel }, dispatch),
)(withStyles(styles)(ExpansionPanelComponent))

class MultiExpansionPanels extends Component {
	constructor(props) {
		super(props)

		props.setExpansionPanels(
			props.arr.reduce((acc, el) => {
				console.log(el)
				acc[el.title] = Boolean(el.open)
				console.log(acc)
				return acc
			}, {}),
		)
	}

	// componentDidMount() {
	//   console.log(this.props.arr)

	//   this.props.setExpansionPanels(
	//     this.props.arr.reduce((acc, el) => {
	//       console.log(el)
	//       acc[el.title] = Boolean(el.open)
	//       console.log(acc)
	//       return acc
	//     }, {}),
	//   )
	// }

	componentDidUpdate(prevProps) {
		// console.log(prevProps)
		// console.log(this.props)

		const { updateExpansionPanels, arr } = this.props

		updateExpansionPanels(
			arr.reduce((acc, el, idx) => {
				if (!prevProps.arr[idx] || prevProps.arr[idx].title !== el.title) {
					// console.log('hits if')
					acc[el.title] = Boolean(el.open)
				}
				return acc
			}, {}),
		)
	}

	componentWillUnmount() {
		this.props.setExpansionPanels({})
	}

	render() {
		const { arr } = this.props

		return (
			<Fragment>
				{arr.map((current, idx) => (
					<CustomExpansionPanel
						current={current.title}
						toolTipText={current.toolTip}
						prev={idx && arr[idx - 1].title}
						idx={idx}
						next={arr[idx + 1] && arr[idx + 1].title}
						last={idx === arr.length - 1}
						color={current.color}
						customClassName={current.customClassName}
						noPadding={current.noPadding}
					>
						{current.component}
					</CustomExpansionPanel>
				))}
			</Fragment>
		)
	}
}

export default connect(null, (dispatch) =>
	bindActionCreators({ setExpansionPanels, updateExpansionPanels }, dispatch),
)(MultiExpansionPanels)

/*
  panel arr gets passed to MultiExpansionPanels
  has access to title (the key), expanded, color
  prevExpanded, expanded, nextExpanded
  on mount, this arr gets made into an obj for state
  if the arr changes, this updates state in componentDidUpdate
*/
